import React, { useState, useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import Content from "../../../Components/Dashboard/Content/Content";
import { GET_ALL_FAQ_DATA } from "../../../ReduxStore/Slice/Superadmin/ApiCreateInfoSlice";
import { useDispatch } from "react-redux";

const FaqAccordion = () => {
  const dispatch = useDispatch();
  const [expandedIndex, setExpandedIndex] = useState(-1);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOption, setFilterOption] = useState("all");
  const [faqData, SetfaqData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null); // 🔹 For image modal

  const user_role = JSON.parse(localStorage.getItem("user_role"));

  const toggleAccordion = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };

  const filteredFaqs = faqData.filter((faq) => {
    const matchesSearch = faq.question
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesFilter = filterOption === "all" || filterOption === faq.type;
    return matchesSearch && matchesFilter;
  });

  const fetchFaqData = async () => {
    try {
      const response = await dispatch(GET_ALL_FAQ_DATA({})).unwrap();
      if (response.status) {
        SetfaqData(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch FAQ data:", error);
    }
  };

  useEffect(() => {
    fetchFaqData();
  }, []);

  return (
    <Content
      Page_title={"Frequently Asked Questions"}
      Filter_tab={true}
      button_status={false}
    >
      <div className="faq-controls row mb-3">
        <div className="col-md-6">
          <input
            type="text"
            placeholder="Search FAQ ..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="faq-search form-control"
          />
        </div>
        <div className="col-md-6 text-end mt-2 mt-md-0">
          <select
            value={filterOption}
            onChange={(e) => setFilterOption(e.target.value)}
            className="faq-filter form-select"
          >
            <option value="all">All FAQs</option>
            <option value="software">Software FAQs</option>
            <option value="mt4">MT-4 FAQs</option>
            <option value="api">API Login With Broker FAQs</option>
            <option value="trade">Trade Issue FAQs</option>
          </select>
        </div>
      </div>

      {filteredFaqs.length === 0 ? (
        <p className="faq-empty">No FAQs found.</p>
      ) : (
        filteredFaqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-header" onClick={() => toggleAccordion(index)}>
              <p className="faq-question mb-0">{faq.question}</p>
              <i
                className={`fas fa-chevron-down faq-icon ${
                  expandedIndex === index ? "rotate" : ""
                }`}
              />
            </div>

            <CSSTransition
              in={expandedIndex === index}
              timeout={300}
              classNames="faq-content"
              unmountOnExit
            >
              <div className="faq-body">
                {/* faq.answer html me aa rha eh isliye */}
                <div dangerouslySetInnerHTML={{ __html: faq.answer }} />

                {faq.answer1 && <p className="faq-answer">{faq.answer1}</p>}

                {(faq.img1 || faq.img2) && (
                  <div className="faq-images d-flex gap-3 mt-2">
                    {faq.img1 && (
                      <img
                        src={faq.img1}
                        alt="FAQ"
                        onClick={() => setSelectedImage(faq.img1)} // 🔹 Click to open modal
                        style={{ cursor: "pointer", maxWidth: "150px" }}
                      />
                    )}
                    {faq.img2 && (
                      <img
                        src={faq.img2}
                        alt="FAQ"
                        onClick={() => setSelectedImage(faq.img2)} // 🔹 Click to open modal
                        style={{ cursor: "pointer", maxWidth: "150px" }}
                      />
                    )}
                  </div>
                )}
              </div>
            </CSSTransition>
          </div>
        ))
      )}

      {/* 🔹 Modal for Image Preview */}
      {selectedImage && (
        <div
          className="image-modal"
          onClick={() => setSelectedImage(null)} // Close when clicking outside
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <img
            src={selectedImage}
            alt="Preview"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "10px",
              boxShadow: "0 0 20px rgba(0,0,0,0.5)",
            }}
          />
          <button
            onClick={() => setSelectedImage(null)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "white",
              border: "none",
              padding: "10px 15px",
              borderRadius: "50%",
              cursor: "pointer",
              fontSize: "18px",
            }}
          >
            ✕
          </button>
        </div>
      )}
    </Content>
  );
};

export default FaqAccordion;
